import { useShallow } from "zustand/shallow";
import { useUserStore } from "../user/state/store";
import { getEffectiveVendViewMode } from "./effectiveUser";
import {
  getSuperuserSupportContextKey,
  useSuperuserContextStore,
} from "./state/superuserContext";
import { accountTaskIdentityKey } from "./taskIdentity";
import {
  selectedAccountContext,
  useAccountContextStore,
} from "./state/accountContext";

export { accountTaskIdentityKey } from "./taskIdentity";

export const getTaskIdentityKey = () => {
  const viewMode = getEffectiveVendViewMode();
  const supportContext = getSuperuserSupportContextKey();
  if (supportContext !== "account") {
    return `${viewMode}:${supportContext}`;
  }
  const accountContext = selectedAccountContext();
  if (accountContext) return accountContext.id;
  const user = useUserStore.getState();
  return accountTaskIdentityKey(viewMode, user.id || "");
};

export const useTaskIdentityKey = () => {
  const userKey = useUserStore(
    useShallow((state) => ({
      id: state.id || "",
      viewMode: state.viewMode || "org",
    })),
  );
  const supportKey = useSuperuserContextStore(
    useShallow((state) => ({
      enabled: state.enabled,
      selectedOrgId: state.selectedOrg?.id || "",
      selectedAccountId: state.selectedAccount?.id || "",
      selectedAccountSource: state.selectedAccount?.source || "",
    })),
  );
  const selectedContextId = useAccountContextStore(
    (state) => state.selectedContextId,
  );
  if (supportKey.enabled && supportKey.selectedOrgId) {
    const viewMode =
      supportKey.selectedAccountSource === "location_contact" ? "contact" : "org";
    return `${viewMode}:support:${supportKey.selectedOrgId}:${supportKey.selectedAccountId}`;
  }
  if (selectedContextId) return selectedContextId;
  return accountTaskIdentityKey(userKey.viewMode, userKey.id);
};
